module.exports = __webpack_public_path__ + "img/youtube-icon-wit.f2e87ea0edcc91d12b957c865f2a2c82.svg";